<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      title="批量修改"
      id-key="ClassId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="() => {}"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="被调整值">
          <el-select v-model="data.ChangeField">
            <el-option :value="0" label="零售价"></el-option>
            <el-option :value="1" label="批发价"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计算公式">
          <!-- 0加，1减，2乘，3除，4等于 -->
          <el-select v-model="data.ChangeMode">
            <el-option :value="0" label="加"></el-option>
            <el-option :value="1" label="减"></el-option>
            <el-option :value="2" label="乘"></el-option>
            <el-option :value="3" label="除"></el-option>
            <el-option :value="4" label="等于"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整值">
          <el-input type="number" v-model.number="data.ChangeValue" placeholder="请输入调整值" />
        </el-form-item>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        Ids: [],
        ChangeField: 0,
        ChangeMode: 0,
        ChangeValue: 0,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/sa/goodsPrice").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        ClassNo: [{ required: true, message: "请输入分类编码" }],
        ClassName: [{ required: true, message: "请输入分类名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened(data) {
        console.log('data',data);
        this.data.Ids = data
    },

    onEditOpened(data) {},
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        this.$refs.dialog.isLoading = true;
        this.api.updates(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$parent.findList()
            this.$message.success(res.Msg||"操作成功");
            this.close(true);
           
          } else this.$message.error(res.Msg);
        });
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
